
// https://v0.sanity.nuxtjs.org/getting-started/quick-start
import { SanityFile } from '@nuxtjs/sanity/dist/components/sanity-file';

export default {
  name: 'FileDownloadComponent',
  components: { SanityFile },
  props: {
    data: {
      type: Object,
      default() {
        return {};
      }
    },
    label: {
      type: String,
      default: null
    },
    icon: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    isSafari() {
      let safariAgent = false;
      if (process.client) {
        const userAgentString = navigator.userAgent;
        safariAgent = userAgentString.includes('Safari');
        const chromeAgent = userAgentString.includes('Chrome');

        // Discard Safari since it also matches Chrome
        if (chromeAgent && safariAgent) {
          safariAgent = false;
        }
      }
      return Boolean(safariAgent);
    },
    hasData() {
      return !!this.data;
    },
    assetId() {
      return this.data.file.asset._ref ?? null;
    },
    downloadName() {
      return this.data.name ?? null;
    }
  }
};
